import { createSelector } from 'reselect'

const _getCourseLevels = (state, selectedCourse) => {
  if (!selectedCourse) {
    return []
  } else {
    return state.mockcourses.items.find(mc => mc.id === selectedCourse.id)
      .mock_levels
  }
}

export const courseLevels = createSelector([_getCourseLevels], levels => {
  return levels
})



// WEBPACK FOOTER //
// ./src/selectors/courselevels.js